"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LineInfo = void 0;
/**
 *
 *
 */
class LineInfo {
    lineColor;
    fillColor;
    //private int lineWidth = 2;
    stroke;
    _Polylines;
    constructor() {
    }
    setLineColor(value) {
        this.lineColor = value;
    }
    getLineColor() {
        return this.lineColor;
    }
    setFillColor(value) {
        this.fillColor = value;
    }
    getFillColor() {
        return this.fillColor;
    }
    getStroke() {
        return this.stroke;
    }
    //client will use this to do fills (if it is not null)
    /*
        public TexturePaint getTexturePaint()
        {
            return texturePaint;
        }
        public void setTexturePaint(TexturePaint value)
        {
            texturePaint=value;
        }*/
    setStroke(s) {
        this.stroke = s;
    }
    getPolylines() {
        return this._Polylines;
    }
    setPolylines(value) {
        this._Polylines = value;
    }
}
exports.LineInfo = LineInfo;
//# sourceMappingURL=LineInfo.js.map